import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';

import CloseIcon from '../../../../assets/images/close-icon.svg';
import DirectoryFilter from './DirectoryFilter';
import Button from '../../../../components/Buttons/DialogButton';
import dataModel from '../../../../models/DataModel';
import './DirectoryFilterPopout.scss';

// Change DialogButton to the appropriate name
class DirectoryFilterPopout extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      changedData: false,
      selectedMarket:
        props.selectedFilters && props.selectedFilters.market
          ? props.selectedFilters.market
          : null,
      selectedCompany:
        props.selectedFilters && props.selectedFilters.company
          ? props.selectedFilters.company
          : null,
      selectedPermission:
        props.selectedFilters && props.selectedFilters.permission
          ? props.selectedFilters.permission
          : null,
      selectedDocumentType:
        props.selectedFilters && props.selectedFilters.documentType
          ? props.selectedFilters.documentType
          : null,
      startDate:
        props.selectedFilters && props.selectedFilters.startDate
          ? props.selectedFilters.startDate
          : null,
      endDate:
        props.selectedFilters && props.selectedFilters.endDate
          ? props.selectedFilters.endDate
          : null,
      selectedFilters: props.selectedFilters ? props.selectedFilters : {},
    };
  }

  handleMarketSelection(market) {
 
    let copySelectedFilters = Object.assign({}, this.state.selectedFilters);
    copySelectedFilters.market = market;
    
    this.setState({
      selectedMarket: market,
      selectedFilters: copySelectedFilters,
      changedData: true,
    });
  }

  handleCompanySelection(company) {
    let copySelectedFilters = Object.assign({}, this.state.selectedFilters);
    copySelectedFilters.company = company;
    this.setState({
      selectedCompany: company,
      selectedFilters: copySelectedFilters,
      changedData: true,
    });
  }

  handlePermissionSelection(permission) {
    let copySelectedFilters = Object.assign({}, this.state.selectedFilters);
    copySelectedFilters.permission = permission;
    //permission.length == 0 ? null : true
    this.setState({
      selectedPermission: permission,
      selectedFilters: copySelectedFilters,

      changedData: true,
    });
  }

  handleDocumentTypeSelection(documentType) {
    let copySelectedFilters = Object.assign({}, this.state.selectedFilters);
    copySelectedFilters.documentType = documentType;
    this.setState({
      selectedDocumentType: documentType,
      selectedFilters: copySelectedFilters,
      changedData: true,
    });
  }

  handleStartDateSelection(date) {
    let copySelectedFilters = Object.assign({}, this.state.selectedFilters);
    copySelectedFilters.startDate = date;
    this.setState({
      startDate: date,
      selectedFilters: copySelectedFilters,
      changedData: true,
    });
  }

  handleEndDateSelection(date) {
    let copySelectedFilters = Object.assign({}, this.state.selectedFilters);
    copySelectedFilters.endDate = date;
    this.setState({
      endDate: date,
      selectedFilters: copySelectedFilters,
      changedData: true,
    });
  }

  handleApplyFilter() {
    this.props.handleCancel();
    let filter = {};
    if (this.state.selectedMarket) {
      filter.market = this.state.selectedMarket;
    }
    if (this.state.selectedCompany) {
      filter.company = this.state.selectedCompany;
    }
    if (this.state.selectedPermission) {
      filter.permission = this.state.selectedPermission;
    }
    if (this.state.selectedCompany) {
      filter.permission = this.state.selectedPermission;
    }

    if (this.props.handleApplyFilter) {
      this.props.handleApplyFilter(filter);
    }
  }

  handleCancel() {
    this.props.handleCancel();
    this.setState({
      changedData: false,
      selectedFilters: null,
      selectedMarket: null,
      selectedCompany: null,
      selectedPermission: null,
    });
  }

  handleClear() {
    this.props.handleClear();
    this.setState({
      changedData: false,
      selectedFilters: null,
      selectedMarket: null,
      selectedCompany: null,
      selectedPermission: null,
    });
  }

  render() {
    const { right, top } = this.props;

    let style = {
      right: right,
      top: top,
    };

    return (
      <div className="directory-users-filter-popout-container" style={style}>
        <div className="arrow-up" />
        <div className="directory-users-filter-popout-header">
          <div className="directory-users-filter-popout-title">{'FILTER DIRECTORY'}</div>
          <img
            className="directory-users-filter-popout-close-icon"
            src={CloseIcon}
            alt="close"
            onClick={this.handleCancel}
          />
        </div>
        <div className="directory-users-filter-popout-filter-container">
          <DirectoryFilter
            handleMarketSelection={this.handleMarketSelection}
            handleCompanySelection={this.handleCompanySelection}
            handlePermissionSelection={this.handlePermissionSelection}
            handleDocumentTypeSelection={this.handleDocumentTypeSelection}
            handleStartDateSelection={this.handleStartDateSelection}
            handleEndDateSelection={this.handleEndDateSelection}
            selectedFilters={this.state.selectedFilters}
            markets={this.props.markets}
            companies={this.props.companies}
          />
        </div>

        <div className="directory-users-button-container">
          <Button
            width={40}
            height={32}
            text={this.textMap.clear.toUpperCase()}
            fontStyle={{
              color: '#9b9b9b',
              fontFamily: 'Open Sans',
              fontSize: '12px',
              letterSpacing: '0px',
              lineHeight: '32px',
            }}
            fill="#ffffff"
            handleClick={this.handleClear}
          />
          {this.state.changedData ?
            <Button
              width={60}
              height={32}
              text={this.textMap.apply.toUpperCase()}
              fontStyle={{
                color: '#ffffff',
                fontFamily: 'Open Sans',
                fontSize: '12px',
                letterSpacing: '0px',
                lineHeight: '32px',
              }}
              fill="#5db348"
              handleClick={this.handleApplyFilter}
            /> :
            <Button
              width={60}
              height={32}
              text={this.textMap.apply.toUpperCase()}
              disabled={true}
              border={'solid 1px #5db348'}
              fontStyle={{
                color: '#5db348',
                fontFamily: 'Open Sans',
                fontSize: '12px',
                letterSpacing: '0px',
                lineHeight: '32px',
              }}
              fill="#ffffff"
            />
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    currentCompany: state.new_companies.currentCompany,
  };
};

// For handling state change from a dispatch
const mapDispatchToProps = dispatch => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(DirectoryFilterPopout);



// WEBPACK FOOTER //
// ./src/containers/Directory/DirectorySearchFilter/DirectoryFilterPopout/index.js